jQuery(document).ready(function($) { 

	// clique sur bn
	$( "#content_s_2 a" ).click(function() {
  		
	
	jQuery.post(
    ajaxurl,
    {
        'action': 'click_btn_telecharger_dossier',
        'param': 'Dossier-demande-dadmission'
    },
    function(response){
            console.log(response);
        }
	);


	})

  ///// MENU MOBILE /////
 //////////////////////////

	  var menu_mobile = $('#primary-menu').clone();
	  var accueil_href = $('.site-title a').attr('href');
	 menu_mobile.prepend('<li><a href="'+accueil_href+'">Accueil</a></li>');

	  menu_mobile.slicknav({
	    duration:300,
	    beforeOpen:move_body,
	    beforeClose:move_body,
	    allowParentLinks:true,
	    nestedParentLinks:true, // tester si c'est ok sinon false pour séparer le lien parent du s-menu
	  });

	  function move_body(){

	    if($('.slicknav_btn').hasClass('slicknav_open')){
	      $('body').addClass('move_to_right');
	    }else{
	      $('body').removeClass('move_to_right');
	    }
	  }

	// FIN MENU MOBILE //
	////////////////////


	 /////////////////////////////////
	// ACCORDEON SPECIAL CANDIDATURE //
	 $('.accordion-c-content').not( "#content_s_0" ).hide();
	  	function close_accordion_candidature() {
        $('a.single-accordeon-c').removeClass('active');
        $('.content_accordeon_c .accordion-c-content').slideUp(300).removeClass('open');
    }

	  $('a.single-accordeon-c').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');

        var pos_top = parseInt($(".content_accordeon_c").position().top);
 		$('html,body').animate({
		        scrollTop: pos_top + 12}, 500, 'swing', function () {
	           // window.location.hash = target;

	        });

 
        if($(this).hasClass('active')) {
          
           //close_accordion_section();
           // $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open'); 
            $('.content_accordeon_c ' + currentAttrValue).slideUp(300).removeClass('open');
            $(this).removeClass('active');

            // on ouvre le numero 0 //
            $('.content_accordeon_c #content_s_0' ).slideDown(300).addClass('open'); 

        }else {
            close_accordion_candidature();
 
            // Add active class to section title
            $(this).addClass('active');
            // Open up the hidden content panel
            $('.content_accordeon_c ' + currentAttrValue).slideDown(300).addClass('open'); 
        }
 
        e.preventDefault();
    });

	/// FIN ACCORDEON SPECIAL CANDIDATURE ///
		/////////////////////////////

	 ////////////////
	 /// ACORDEON //
	 // .not( "#content_s_1" )
	 $('.accordion-section-content').hide();
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
   	// ACCORDEON SECTION 
   	function close_accordion_section() {
        $('.accordeon-page .accordion-section-title').removeClass('active');
        $('.accordeon-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
 
        if($(this).hasClass('active')) {
          
           // close_accordion_section();
           // $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open'); 
            $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open');
            $(this).removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).addClass('active');
            // Open up the hidden content panel
            $('.accordeon-page ' + currentAttrValue).slideDown(300).addClass('open'); 
        }
 
        e.preventDefault();
    });
    // FIN ACCORDEON //
    ////////////////////

	 $('.gallery').featherlightGallery();

	 $(window).scroll(function () {
	
	 		scroll_filiere();
	
    });

	 function scroll_filiere(){

	 	if ( $( "#schema_filiere" ).length ) {

	 		var l_window = parseInt($(window).width());
	 		var position_schema_filiere = $("#schema_filiere").position().top;
	 		var fin_pos_schema = parseInt(position_schema_filiere+$("#schema_filiere").height() - 220);
			if (l_window > 1050){
	            if ($(window).scrollTop() > position_schema_filiere && $(window).scrollTop() < fin_pos_schema ){
					$("#schema_filiere").addClass("fixed_scrol");
	            }else{
	            	$("#schema_filiere").removeClass("fixed_scrol");
	            }
	        }
		}
	 }
	   
	 
	 /////////////// MENU MOBILE ////////////
	

	  // // menu mobile
	  // var menu_mobile = $('#primary-menu').clone();
	
	  // menu_mobile.slicknav({
	  //   duration:300,
	  //   beforeOpen:move_body,
	  //   beforeClose:move_body
	  // });

	  // function move_body(){

	  //   if($('.slicknav_btn').hasClass('slicknav_open')){
	  //     $('body').addClass('move_to_right');
	  //   }else{
	  //     $('body').removeClass('move_to_right');
	  //   }
	  // }


	 ////////////// FIN MENU MOBILE ////////
		///// SCROLL + CLICK HOME PAGE //////
	///// ////// //// ///// /////// ///// 
	


	///// ////// //// DIAPORAMA TOP HOME ///// /////// ///// 


	// OWL CAROUSEL HOME
	 var owl_home_page = $("#home_sticky");

 	if ( $( owl_home_page).length ) {
	  owl_home_page.owlCarousel({
	  	 loop:true,
	  	 autoplay:true,
	  	 autoplayTimeout:5500,
	  	 autoplaySpeed:1500,
         navSpeed:1300,
         smartSpeed:1300,
         fluidSpeed:1300,
    	 margin:0,
   		 nav:false,
   		 items:1,
 		   // animateIn: 'fadeInDown',
      //    animateOut: 'slideOutLeft'
	  });
   }

	///// ////// //// FIN DIAPORAMA TOP HOME ///// /////// ///// 




	//	WOW EFFECT //
	  var wow = new WOW(
	    {
	      boxClass:     'wow',      // animated element css class (default is wow)
	      animateClass: 'animated', // animation css class (default is animated)
	      offset:       0,          // distance to the element when triggering the animation (default is 0)
	      mobile:       false,       // trigger animations on mobile devices (default is true)
	      live:         true,       // act on asynchronously loaded content (default is true)
	      callback:     function(box) {
	        // the callback is fired every time an animation is started
	        // the argument that is passed in is the DOM node being animated
	      },
	      scrollContainer: null // optional scroll container selector, otherwise use window
	    }
	  );
	 wow.init();
  // WOW EFFECT //



  // FORM CONTACT LABEL ///
	 $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).click(function() {
	  	$( this ).parent().parent().addClass('focus');
	});
	 $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
	  	$( this ).parent().parent().addClass('focus');
	});

	 $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
  		if($(this).val() != '') $( this ).parent().parent().addClass('focus');
	});


});